export const locateTerms = (organizationCountry: string) => {
  const baseTermsPath = "/static/documents";
  switch (organizationCountry) {
    case "US":
      return `${baseTermsPath}/flicket-ticket-cover-terms-usa-v19.pdf`;
    case "GB":
      return `${baseTermsPath}/flicket-ticket-cover-terms-gb-v19.pdf`;
    default:
      return `${baseTermsPath}/flicket-ticket-cover-terms-v19.pdf`;
  }
};
